import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {useParams} from "react-router";
import {useLocation} from "react-router-dom";
import {useDocumentTitle} from "../../hooks";
import {SEARCH_INSPECTION_HISTORY_RESULT, SEARCH_TREATMENT_HISTORY_DETAIL} from "../../constants/routes";
import getPageBreadcrumb from "../../services/BreadcrumbServices";
import {useSearchTreatmentHistoryDetail} from "../../hooks/searchs/SearchTreatmentHistoryDetailHook";

import BackendLayout from "../../layouts/BackendLayout";
import {
  ButtonBack,
  InspectionResultWithUnit,
  JudgmentLimit,
  Label,
  PageTitle,
  RedirectAlert,
  RemarkDetail
} from "../../components";
import * as ArrayUtils from "../../utils/array-utils";
import Table from "../../components/table/Table";
import PageEditIcon from "../../assets/icons/page-edit-icon.svg";
import SettingIcon from "../../assets/icons/setting-big-icon.svg";
import NetWorkIcon from "../../assets/icons/search-screen-machine-group-icon.png";
import {getSearchBackUrl} from "../../utils/url-utils";
import {
  getInspectionJudgment, getInspectionResutlBackground, getInspectionResutlColor, getInspectionResutlSymbol, getInspectionUnit
} from "../../utils/display-utils";
import _ from "lodash";
import ReadonlyComment from "../../components/ReadonlyComment"
import useRedirectPage from "../../hooks/useRedirectPage";
import {SEARCH_TREATMENT_HISTORY_DETAIL_PAGE} from "../../constants/pageName";

export default function SearchTreatmentHistoryDetail() {
  useRedirectPage(SEARCH_TREATMENT_HISTORY_DETAIL_PAGE);
  const title = '処置履歴';
  useDocumentTitle(title + " - 点検王");
  const {workflow_id, treatment_id} = useParams();
  const groupSettings = useSelector((state) => state.app_settings.machine_group);
  const resultSymbolSetting = useSelector(
    (s) => s.app_settings.inspection_display.inspection_result_symbol
  );

  const [inspectionItems, setInspectionItems] = useState([]);
  const location = useLocation();
  const searchTreatment = location.state || {};
  const { searchParams, inspection } = useSearchTreatmentHistoryDetail(workflow_id, treatment_id, searchTreatment);

  useEffect(() => {
    if (!_.isEmpty(inspection)) {
      setInspectionItems(inspection.template?.inspection_template);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inspection]);

  const handleBack = () => {
    window.location.href = getSearchBackUrl(searchParams, '', SEARCH_INSPECTION_HISTORY_RESULT);
  };

  const breadcrumb = getPageBreadcrumb(SEARCH_TREATMENT_HISTORY_DETAIL, handleBack);


  const getDateTimeFormat = (dateTime, type = 'datetime') => {
    if (dateTime === undefined || dateTime === null) return "-";

    const [datePart, timePart] = dateTime.split('T');
    const [year, month, day] = datePart.split('-');
    if (type === 'date') {
      return `${year}年${month}月${day}日`;
    }
    // eslint-disable-next-line no-unused-vars
    const [hours, minutes, seconds] = timePart.split(':');
    return `${year}/${month}/${day} ${hours}:${minutes}`;
  }

  const getUserFormat = (user) => {
    if (user === undefined || user.name === null) return "-";
    let result = user.name;
    if (user.username) {
      result = result + " (" + user.username + ")";
    }
    return result;
  }

  return (
    <BackendLayout breadcrumb={breadcrumb} sidebar={true}>
      <PageTitle title={title}　/>
      <RedirectAlert />
      <div className="xl:mt-6 mt-5 w-fit lg:w-full pr-[24px] lg:pr-0" id="top_scroll">
        <div className="flex space-x-5 xl:space-x-[10px]">
          <div className="flex items-center rounded-[8px] bg-white border border-[#E0E0E0] pl-2 xl:pl-[16px] lg:space-x-4 space-x-2">
            {ArrayUtils.range(1, 5).map((i, idx) =>
              groupSettings[`group_${i}`]?.active && (
                <div className="flex flex-col" key={idx}>
                  <Label text={groupSettings[`group_${i}`]?.name} className="font-light text-[#616161] py-1 whitespace-nowrap" />
                  <span
                    className="text-left font-medium pb-2 truncate lg:max-w-[240px] max-w-[228px]"
                    title={inspection.machine?.group_relation[`group_${i}`]?.name || '-'}
                  >
                    {inspection.machine?.group_relation[`group_${i}`]?.name || '-'}
                  </span>
                </div>
              )
            )}
            <div className="min-w-[45px] xl:min-w-[55px]">
              <img src={NetWorkIcon} alt="group-icon" className="w-auto h-[38px] xl:h-[42px] px-[4px] xl:px-[12px]" />
            </div>
          </div>
          <div className="flex items-center rounded-[8px] bg-white border border-[#E0E0E0] pl-2 xl:pl-[16px]">
            <div className="flex flex-col lg:mr-2 mr-1">
              <Label text={groupSettings.machine?.name} className="font-light text-[#616161] py-1 whitespace-nowrap"/>
              <span className="text-left font-medium pb-2 lg:max-w-[240px] max-w-[228px] truncate"
                    title={inspection.machine?.name}>{inspection.machine?.name}</span>
            </div>
            <div className="min-w-[45px] xl:min-w-[55px]">
              <img src={SettingIcon} alt="machine-icon" className="w-auto h-[38px] xl:h-[42px] px-[4px] xl:px-[12px]"/>
            </div>
          </div>
          <div className="flex items-center rounded-[8px] bg-white border border-[#E0E0E0] pl-2 xl:pl-[16px]">
            <div className="flex flex-col lg:mr-2 mr-1">
              <Label text="点検テンプレート名" className="font-light text-[#616161] py-1 whitespace-nowrap"/>
              <span 
                className="text-left font-medium pb-2 lg:max-w-[240px] max-w-[228px] truncate"
                title={inspection.template?.name}
              >
                {inspection.template?.name}
              </span>
            </div>
            <div className="min-w-[45px] xl:min-w-[55px]">
              <img src={PageEditIcon} alt="template-icon" className="w-auto h-[38px] xl:h-[42px] px-[4px] xl:px-[12px]"/>
            </div>
          </div>
        </div>

        <div className="xl:mt-[16px] mt-2 w-full">
          <div className="border border-[#e0e0e0] rounded-[8px]">
            <Table striped>
              <Table.Head className="border-b border-tenken-gray-200">
                <Table.HeadCell className="!normal-case w-[76px]">
                  <span>No.</span>
                </Table.HeadCell>
                <Table.HeadCell>
                  <span className="whitespace-nowrap">点検項目</span>
                </Table.HeadCell>
                <Table.HeadCell>
                  <span className="whitespace-nowrap">判定基準</span>
                </Table.HeadCell>
                <Table.HeadCell>
                  <span className="whitespace-nowrap">下限</span>
                </Table.HeadCell>
                <Table.HeadCell>
                  <span className="whitespace-nowrap">上限</span>
                </Table.HeadCell>
                <Table.HeadCell></Table.HeadCell>
                <Table.HeadCell>
                  <span className="whitespace-nowrap">留意事項</span>
                </Table.HeadCell>
                <Table.HeadCell>
                  <span className="whitespace-nowrap">点検結果</span>
                </Table.HeadCell>
              </Table.Head>
              {(inspectionItems && inspection.treatment && inspection.treatment[0]?.inspection_results.length > 0) && (
                <Table.Body className="text-base text-gray-900">
                  {inspection.treatment[0]?.inspection_results.map((row, index) => {
                    const inspectionItem = inspectionItems.find(item => item.id == row.inspection_item_id);
                    return inspectionItem && (
                    <Table.Row key={index}>
                      <Table.Cell>{index + 1}</Table.Cell>
                      <Table.Cell className="max-w-[400px]">
                        <span
                          style={{color: inspectionItem?.title_color}}
                          className="break-all"
                        >
                          {inspectionItem.title}
                        </span>
                      </Table.Cell>
                      <Table.Cell className="max-w-[300px]">
                        <span
                          style={{color: inspectionItem?.description_color}}
                          className="break-all"
                        >
                          {inspectionItem?.description}
                        </span>
                      </Table.Cell>
                      <Table.Cell className="max-w-[300px]">
                        <JudgmentLimit
                          value={inspectionItem?.inspection_judgment?.lower_value}
                          boundaryType={inspectionItem?.inspection_judgment?.lower_boundary_type}
                          unit={inspectionItem?.unit}
                          type="lower"
                        />
                      </Table.Cell>
                      <Table.Cell className="max-w-[300px]">
                        <JudgmentLimit
                          value={inspectionItem?.inspection_judgment?.upper_value}
                          boundaryType={inspectionItem?.inspection_judgment?.upper_boundary_type}
                          unit={inspectionItem?.unit}
                          type="upper"
                        />
                      </Table.Cell>
                      <Table.Cell>
                        <span
                          title={inspectionItem?.unit}
                          className="whitespace-nowrap"
                        >
                          {inspectionItem?.unit ? getInspectionUnit(inspectionItem?.unit, true) : '-'}
                        </span>
                      </Table.Cell>
                      <Table.Cell>
                        <RemarkDetail key={index} rowData={inspectionItem}/>
                      </Table.Cell>
                      <Table.Cell className="max-w-[300px]">
                        <span
                          style={{
                            color: getInspectionResutlColor(row.result, resultSymbolSetting),
                            background: getInspectionResutlBackground(row.result, resultSymbolSetting),
                          }}>
                        {getInspectionResutlSymbol(row.result, resultSymbolSetting,)}
                        </span>
                        {inspectionItem?.inspection_item_type?.name === 'input' && (
                          <InspectionResultWithUnit
                            inspectionResult={row.inspection_item_value}
                            unit={inspectionItem?.unit}
                            className="ml-1"
                          />
                        )}
                      </Table.Cell>
                    </Table.Row>
                    )}
                  )}
                </Table.Body>
              )}
            </Table>
          </div>
        </div>

        <div className="w-full xl:mt-[16px] mt-2 rounded-[8px]">
          <div className="border border-[#e0e0e0] rounded-[8px]">
            <Table striped>
              <Table.Head className="">
                <Table.HeadCell className="px-2 xl:px-[16px]" colSpan={2}>処置履歴</Table.HeadCell>
              </Table.Head>
              <Table.Body className="text-[14px] xl:text-base text-gray-900">
                <Table.Row>
                  <Table.Cell>処置担当者({inspection.treatment && inspection.treatment[0]?.treatment_number}回目)</Table.Cell>
                  <Table.Cell className="px-2 xl:px-[16px]">{inspection.treatment && getUserFormat(inspection.treatment[0]?.treatment_user)}</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>処置日時({inspection.treatment && inspection.treatment[0]?.treatment_number}回目)</Table.Cell>
                  <Table.Cell className="px-2 xl:px-[16px]">{inspection.treatment && getDateTimeFormat(inspection.treatment[0]?.treatment_datetime)}</Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </div>
        </div>

        <div className="flex flex-col 2xl:p-[24px] xl:p-[20px] md:p-[16px] bg-[#FFF] justify-center item-center  border border-[#e0e0e0] gap-[20px] w-full xl:mt-[16px] mt-2 rounded-[8px]">
          <Label className="font-medium" text="処置コメント"/>
          <ReadonlyComment
            remarkText={inspection.treatment && inspection.treatment[0].remark_text}
            commentFiles={inspection.treatment && inspection.treatment[0].treatment_comment_files}
          />
        </div>

        <div className="flex items-center py-[20px] 2xl:gap-[120px] xl:gap-[100px] md:gap-[80px] justify-center" id="end_scroll">
          <ButtonBack onClick={handleBack}/>
        </div>
      </div>
    </BackendLayout>
  );
}
